import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-84fc5c20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1))
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1))
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Titre "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Date Composition "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Date Limite "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Professeur "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Filière "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Niveau "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Matière "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
    }, " ACTIONS ")
  ])
], -1))
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_14 = {
  key: 0,
  class: "d-block text-warning"
}
const _hoisted_15 = {
  key: 1,
  class: "d-block text-danger"
}
const _hoisted_16 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0" }
const _hoisted_22 = { class: "dropdown" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1))
const _hoisted_24 = { class: "dropdown-menu dropdown-block" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_27 = {
  key: 1,
  class: "dropdown-divider"
}
const _hoisted_28 = { key: 2 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_30 = { key: 3 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pencil-square-o lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_32 = {
  key: 4,
  class: "dropdown-divider m-0"
}
const _hoisted_33 = { key: 5 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bar-chart lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_35 = {
  key: 6,
  class: "dropdown-divider m-0"
}
const _hoisted_36 = { key: 7 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash-o lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_39 = { key: 8 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dropdown-item d-flex align-items-center text-muted disabled-info" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle lh-1 me-8 position-relative top-1" }),
  /*#__PURE__*/_createTextVNode(" (Devoirs soumis pour cette composition déjà) ")
], -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.checkPermission('AddComposition'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "btn btn-primary",
              to: "/ajouter-composition"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" Ajouter une composition ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          class: "search-box position-relative",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher une composition"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _hoisted_6
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compositions, (composition, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_11, _toDisplayString(composition.titre), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.formatDate(composition.dateComposition)), 1),
                _createElementVNode("td", _hoisted_13, [
                  (composition.dateFinSoumission || composition.dateComposition)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(_ctx.getDateStatusClass(composition.dateFinSoumission || composition.dateComposition))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(composition.dateFinSoumission || composition.dateComposition)) + " ", 1),
                        (_ctx.joursRestants(composition) > 0 && _ctx.joursRestants(composition) <= 3)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_14, " J-" + _toDisplayString(_ctx.joursRestants(composition)), 1))
                          : _createCommentVNode("", true),
                        (_ctx.joursRestants(composition) <= 0)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_15, " Expirée "))
                          : _createCommentVNode("", true)
                      ], 2))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, "Non définie"))
                ]),
                _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.fullName(composition.professeur)), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(composition.filiereNiveauMatiere?.filiere?.libelle || '-'), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(composition.filiereNiveauMatiere?.niveau?.libelle || '-'), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(composition.filiereNiveauMatiere?.matiere?.libelle || '-'), 1),
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("ul", _hoisted_24, [
                      (!_ctx.isDisciple)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                            _createVNode(_component_router_link, {
                              to: { name: 'ViewCompositionPage', params: { id: composition.id } },
                              class: "dropdown-item d-flex align-items-center"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_26,
                                _createTextVNode(" Détails ")
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.canShowEditOrDelete(composition))
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_27))
                        : _createCommentVNode("", true),
                      (_ctx.canEdit(composition) && !composition.hasDevoirs)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                            _createVNode(_component_router_link, {
                              to: { name: 'EditCompositionPage', params: { id: composition.id } },
                              class: "dropdown-item d-flex align-items-center"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_29,
                                _createTextVNode(" Modifier ")
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.checkPermission('VoirDevoir') && !composition.estExpire && (!composition.dejaSoumis || composition.peutEncoreComposer))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                            _createVNode(_component_router_link, {
                              to: { name: 'DetailsCompositionPage', params: { id: composition.id } },
                              class: "dropdown-item d-flex align-items-center text-success fw-bold"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_31,
                                _createTextVNode(" " + _toDisplayString(composition.dejaSoumis ? 'Recommencer' : 'Composer'), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.checkPermission('VoirDevoir'))
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_32))
                        : _createCommentVNode("", true),
                      (_ctx.checkPermission('VoirResultat') && composition.dejaSoumis)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                            _createVNode(_component_router_link, {
                              to: { name: 'ResultatCompositionPage', params: { id: composition.id } },
                              class: "dropdown-item d-flex align-items-center text-primary fw-bold"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_34,
                                _createTextVNode(" Voir mon résultat ")
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.checkPermission('VoirResultat'))
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_35))
                        : _createCommentVNode("", true),
                      (_ctx.canDelete(composition) && !composition.hasDevoirs)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                            _createElementVNode("a", {
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.suppression(composition.id, _ctx.compositions, 'compositions', `la composition ${composition.titre}`)),
                              class: "dropdown-item d-flex align-items-center text-danger"
                            }, [
                              _hoisted_38,
                              _createTextVNode(" Supprimer ")
                            ], 8, _hoisted_37)
                          ]))
                        : _createCommentVNode("", true),
                      (composition.hasDevoirs && _ctx.canEditOrDelete(composition))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_39, _hoisted_41))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}